import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Chevron Up Stroke
 */

export default function ChevronUpStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M7.67364 4.14645C7.85389 3.95118 8.14612 3.95118 8.32636 4.14645L13.8648 10.1464C14.0451 10.3417 14.0451 10.6583 13.8648 10.8536C13.6846 11.0488 13.3923 11.0488 13.2121 10.8536L8 5.20711L2.7879 10.8536C2.60765 11.0488 2.31542 11.0488 2.13518 10.8536C1.95494 10.6583 1.95494 10.3417 2.13518 10.1464L7.67364 4.14645Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
